(() => {
  const key = 'archquick.wishlist.v1';
  const dialog = document.querySelector('.aq-wishlist-dialog');
  if (!dialog) return;
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value.filter(p => p && /^\d+$/.test(p.id) && typeof p.title === 'string' && typeof p.url === 'string' && p.url.startsWith('/') && !p.url.startsWith('//')).slice(0, 100) : [];
    } catch { return []; }
  };
  let saved = read();
  const sync = () => {
    document.querySelectorAll('[data-aq-save]').forEach(button => button.setAttribute('aria-pressed', String(saved.some(p => p.id === button.dataset.id))));
    document.querySelectorAll('[data-aq-wishlist-count]').forEach(node => { if (node.textContent !== String(saved.length)) node.textContent = saved.length; });
  };
  const render = () => {
    const items = dialog.querySelector('[data-aq-wishlist-items]');
    items.replaceChildren();
    dialog.querySelector('[data-aq-wishlist-empty]').hidden = saved.length > 0;
    saved.forEach(product => {
      const item = dialog.querySelector('template').content.cloneNode(true);
      const link = item.querySelector('a');
      link.href = product.url;
      item.querySelector('span').textContent = product.title;
      const img = item.querySelector('img');
      if (typeof product.image === 'string' && /^(https:\/\/|\/)/.test(product.image)) img.src = product.image;
      else img.remove();
      item.querySelector('button').addEventListener('click', () => {
        const next = saved.filter(p => p.id !== product.id);
        if (persist(next)) { render(); dialog.querySelector('[data-aq-wishlist-close]').focus(); }
      });
      items.append(item);
    });
  };
  const persist = next => {
    try { localStorage.setItem(key, JSON.stringify(next)); saved = next; sync(); return true; }
    catch { dialog.querySelector('[data-aq-wishlist-status]').textContent = 'Your browser could not save the wishlist. Please allow browser storage and try again.'; if (!dialog.open) dialog.showModal(); return false; }
  };
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-aq-wishlist-open]');
    if (open) {
      document.querySelectorAll('.aq-account-menu').forEach(menu => menu.open = false);
      render(); dialog.showModal(); return;
    }
    if (event.target.closest('[data-aq-wishlist-close]')) { dialog.close(); return; }
    const button = event.target.closest('[data-aq-save]');
    if (!button) return;
    const product = { id: button.dataset.id, title: button.dataset.title, url: button.dataset.url, image: button.dataset.image };
    const exists = saved.some(p => p.id === product.id);
    if (!exists && saved.length >= 100) { render(); dialog.showModal(); dialog.querySelector('[data-aq-wishlist-status]').textContent = 'Your wishlist holds up to 100 products. Remove an item to save another.'; return; }
    persist(exists ? saved.filter(p => p.id !== product.id) : [...saved, product]);
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  window.addEventListener('storage', event => { if (event.key === key) { saved = read(); sync(); if (dialog.open) render(); } });
  new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
  sync();
})();
